import React, { useEffect } from 'react';
import '../pages/Pages.css';

function SocialLinks() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://discord.com/api/guilds/YOUR_GUILD_ID/widget.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="page">
      <h1>Social Links</h1>
      <div className="social-links-container">
        <div className="discord-section">
          <h2>1Hundred Studio</h2>
          <p>Join our community Discord server:</p>
          <a href="https://discord.gg/prx5m8nkjw" target="_blank" rel="noopener noreferrer" className="discord-link">
            Join 1Hundred Studio Discord
          </a>
        </div>

        <div className="discord-section">
          <h2>HSFL Discord</h2>
          <p>Join the HSFL community:</p>
          <a href="https://discord.gg/9xuNayYRCK" target="_blank" rel="noopener noreferrer" className="discord-link">
            Join HSFL Discord
          </a>
        </div>
      </div>
    </div>
  );
}

export default SocialLinks;
